import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Catch-all 404 page for unknown routes, so an unmatched URL shows a real page
 * instead of a blank screen.
 */
export default function NotFound() {
  return (
    <div
      style={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '40px 20px',
        background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)',
        color: '#fff',
        fontFamily: '"Poppins", sans-serif',
      }}
    >
      <div style={{ maxWidth: 480 }}>
        <div style={{ fontSize: '4rem', marginBottom: 16 }}>🔍</div>
        <h1 style={{ fontSize: '2rem', marginBottom: 12 }}>Page not found</h1>
        <p style={{ opacity: 0.75, marginBottom: 28 }}>
          The page you are looking for does not exist or has moved.
        </p>
        <Link
          to="/"
          style={{
            padding: '12px 24px',
            background: 'linear-gradient(135deg, #FE5500, #ff7a00)',
            borderRadius: 8,
            color: '#fff',
            fontWeight: 500,
            textDecoration: 'none',
          }}
        >
          Go to Homepage
        </Link>
      </div>
    </div>
  );
}
